<template>
  <div>
    <div class="d-flex flex-fill flex-column p-2" v-if="tagObject !== null && !this.isProcessing">
      <div class="d-flex justify-content-center text-center" style="font-size:1.5em">
        {{ tagObject.name }}
        <div v-if="this.selectedAccountID !== null">
          &nbsp;-> {{ this.selectedAccountID }}
        </div>
      </div>
      <div style="color: #000000">
        <account-selector v-if="tagObject.account_id === null" v-on:selectedAccount="(e) => { setOrganization(e) }"></account-selector>
      </div>
      <div class="row mt-3">
        <div class="col text-center">
          <button class="btn maadi-button" @click="save">SUBMIT</button>
          <button class="btn maadi-button" @click="setAsNonAccount">IS NOT ACCOUNT</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import AccountSelector from '../../tools/AccountSelector'
import WordpressAPI from '../../../api/wordpressTags'
export default {
  name: '',
  components: {AccountSelector},
  props: ['tagObject'],
  data: function () {
    return {
      isProcessing: false,
      selectedAccountID: null
    }
  },
  methods: {
    setOrganization (e) {
      this.selectedAccountID = e.account_id
      this.tagObject.is_not_account = false
    },
    setAsNonAccount () {
      this.isProcessing = true
      this.tagObject.is_not_account = true
      WordpressAPI.updateTag(this.tagObject.id, this.tagObject).then(
        response => {
          this.isProcessing = false
        }
      )
    },
    save () {
      this.isProcessing = true
      this.tagObject.account_id = this.selectedAccountID
      WordpressAPI.updateTag(this.tagObject.id, this.tagObject).then(
        response => {
          this.isProcessing = false
          this.selectedAccountID = null
        }
      )
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/marcomm/wordpressLinker/SingleWordpressTag.vue